import React from 'react';
import { NavLink, useRouteMatch, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {
  SIDEBAR_ITEM_BUTTON_CLASS_NAME,
  SIDEBAR_ITEM_BUTTON_ACTIVE_CLASS_NAME,
} from '../../../theme/constants/listItemButton';

const SidebarItem = ({ id, label, path, icon, index, open, disabled, showAtBottom, ...props }) => {
  const { path: routePath } = useRouteMatch();
  const location = useLocation();
  const isActive = () => {
    if (location.pathname.includes(path)) return true;
    if (index === 0 && !showAtBottom) {
      return location.pathname === routePath;
    }
    return false;
  };

  const active = isActive();

  return (
    <ListItem disablePadding sx={{ display: 'block' }}>
      <ListItemButton
        id={id}
        className={active ? SIDEBAR_ITEM_BUTTON_ACTIVE_CLASS_NAME : SIDEBAR_ITEM_BUTTON_CLASS_NAME}
        sx={{
          justifyContent: open ? 'initial' : 'center',
        }}
        component={NavLink}
        to={`${routePath}/${path}`}
        disabled={disabled}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: open ? 1 : 'auto',
            justifyContent: 'center',
            color: 'gray.A600',
            ...props,
          }}
        >
          {icon}
        </ListItemIcon>
        <ListItemText
          primary={label}
          sx={{ opacity: open ? 1 : 0 }}
          primaryTypographyProps={{ variant: 'subNavItem', style: { whiteSpace: 'normal' } }}
        />
      </ListItemButton>
    </ListItem>
  );
};

SidebarItem.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  path: PropTypes.string.isRequired,
  icon: PropTypes.element,
  index: PropTypes.number.isRequired,
  showAtBottom: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};
SidebarItem.defaultProps = { disabled: true, icon: null, showAtBottom: false };

export default SidebarItem;
